// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"31":"d469e156","374":"3bb96d7a","479":"4c920813","483":"c6b7a7b9","528":"042b18a5","597":"fe1ff544","681":"a9ee197b","807":"0c33beec"}[chunkId] + ".js";
};